import { CssBaseline, GlobalStyles, ThemeProvider } from '@mui/material';
import { RouterProvider } from '@tanstack/react-router';
import { lightTheme } from 'material';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from 'store';

import { router } from './routes/-router';

// App-level global CSS. Kept here (not in the theme) so it sits next to
// CssBaseline and is easy to find when tuning navigation feel.
//
// View transitions: the browser auto-creates a crossfade between the old
// and new DOM on every router navigation (defaultViewTransition: true in
// -router.ts). Default crossfade is ~250ms — bump animation-duration to
// slow it down, or replace the keyframes entirely for a different effect.
const globalStyles = (
  <GlobalStyles
    styles={{}}
    // styles={{
    //   '::view-transition-old(root), ::view-transition-new(root)': {
    //     animationDuration: '500ms',
    //   },
    // }}
  />
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={lightTheme}>
      <CssBaseline enableColorScheme />
      {globalStyles}
      <Provider store={store}>
        <RouterProvider router={router} />
      </Provider>
    </ThemeProvider>
  </StrictMode>,
);
